import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDeleteStyle0 = cosmosIconCss;

const CosmosIconDelete$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDelete extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0fa580ff62c0cdeb51d71aa66562c5978bbbd2b9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '648d9cc01afc733e22400607b5f042adf2e78f64', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4b89592b590d8a66950beab81ba814b08b7eba33', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 3.5V4h4.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 5v-.5a.5.5 0 0 1 .5-.5H8v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm1.314 13.755.8-8.8A.5.5 0 0 1 16.615 8h.5a.5.5 0 0 1 .5.545l-.887 9.75a.5.5 0 0 1-.5.455H5.775a.5.5 0 0 1-.5-.455l-.887-9.75a.5.5 0 0 1 .5-.545h.5a.5.5 0 0 1 .497.46l.8 8.795h8.629ZM11.991 14.5l.259-6a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5l-.259 6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5Zm-3.741-6 .259 6a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5l-.259-6a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDeleteStyle0; }
}, [1, "cosmos-icon-delete", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-delete"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-delete":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDelete$1);
            }
            break;
    } });
}

const CosmosIconDelete = CosmosIconDelete$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDelete, defineCustomElement };
